  <app-onboarding-header></app-onboarding-header>
  <form class="md:max-w-xl md:m-auto" [formGroup]="registerForm">
    <div class="flex flex-col items-center p-4">
      <h2>{{ 'ONBOARDING.REGISTER.TITLE' | translate }}</h2>

      <zendy-intl-phone class="w-full rounded-none mb-4"
                        formControlName="username"
                        [countries]="(countries | tuiSortCountries | async) || []"
                        [(countryIsoCode)]="countryIsoCode">
      </zendy-intl-phone>


      <mat-form-field class="calls-full-width mb-4">
        <mat-label>{{ 'ONBOARDING.REGISTER.PASS1' | translate }}</mat-label>
        <div class="mt-2">
          <div class="flex items-center rounded-md pl-3 outline-1 -outline-offset-1 outline-gray-300 has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-indigo-600">
            <input [type]="mostrarPassword1 ? 'text' : 'password'" matInput formControlName="password" />
            <div class="grid shrink-0 grid-cols-1 focus-within:relative">
              <mat-icon class="material-icons-outlined cursor-pointer" id="showpassword1" (click)="mostrarpass1()" title="{{ 'ONBOARDING.LOGIN.'+showpasstext1 | translate }} ">{{icon1}}</mat-icon>

            </div>
          </div>
        </div>
        <mat-error *ngIf="registerForm.get('password')?.hasError('pattern')">
          {{ 'ONBOARDING.REGISTER.WHITE_SPACE' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="calls-full-width mb-4">
        <mat-label>{{ 'ONBOARDING.REGISTER.PASS2' | translate }}</mat-label>
        <div class="mt-2">
          <div class="flex items-center rounded-md pl-3 outline-1 -outline-offset-1 outline-gray-300 has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-indigo-600">
            <input [type]="mostrarPassword2 ? 'text' : 'password'" matInput formControlName="password2" />
            <div class="grid shrink-0 grid-cols-1 focus-within:relative">
              <mat-icon class="material-icons-outlined cursor-pointer" id="showpassword2" (click)="mostrarpass2()" title="{{ 'ONBOARDING.LOGIN.'+showpasstext2 | translate }} ">{{icon2}}</mat-icon>

            </div>
          </div>
        </div>
      </mat-form-field>

      <div class="password-hints">
          <div [class.ok]="passwordRequirements.isMinLength">
            ✔ {{ 'ONBOARDING.REGISTER.MIN_LENGTH' | translate }}
          </div>
          <div [class.ok]="passwordRequirements.hasLowercase">
            ✔ {{ 'ONBOARDING.REGISTER.LOWERCASE' | translate }}
          </div>
          <div [class.ok]="passwordRequirements.hasUppercase">
            ✔ {{ 'ONBOARDING.REGISTER.UPPERCASE' | translate }}
          </div>
          <div [class.ok]="passwordRequirements.hasNumber">
            ✔ {{ 'ONBOARDING.REGISTER.NUMBER' | translate }}
          </div>
          <div [class.ok]="passwordRequirements.hasSymbol">
            ✔ {{ 'ONBOARDING.REGISTER.SYMBOL' | translate }}
          </div>
        </div>

      <div class="check-full-width mb-4">
        <mat-label for="acceptTermsCheckbox">
          <input type="checkbox" id="acceptTermsCheckbox" (click)="toggleTerms()">
          {{ 'ONBOARDING.REGISTER.TERMS_START' | translate }} <a target='_blank' href='/about/privacy'>{{ 'ONBOARDING.REGISTER.TERMS_PRIVACY' | translate }}</a> {{ 'ONBOARDING.REGISTER.TERMS_AND' | translate }} <a target='_blank' href='/about/legal'>{{ 'ONBOARDING.REGISTER.TERMS_TERMS' | translate }}</a>
        </mat-label>
      </div>

      <p class="pb-4"></p>
      <app-button (click)="signUp()" [disabled]="!acceptTermsControl">
        {{ 'ONBOARDING.REGISTER.BUTTON' | translate }}
      </app-button>

    </div>
    <div class="p-4">
      <hr />
    </div>
    <div class="flex flex-col items-center p-4">
      <p class="text-sm mb-8 font-medium">
        {{ 'ONBOARDING.REGISTER.QUESTION' | translate }}
      </p>
      <app-button color="secondary" routerLink="/onboarding/login" [replaceUrl]="true">
        {{ 'ONBOARDING.REGISTER.GO_BACK' | translate }}
      </app-button>
    </div>
  </form>

  <div class="loading-mask" *ngIf="showSpinner">
    <mat-spinner diameter="50" strokeWidth="3"></mat-spinner>
  </div>

  <style>
    .mat-mdc-form-field-error {
      color: red;
  }
  .password-hints div {
  color: red;
  font-size: 0.85rem;
}
.password-hints div.ok {
  color: green;
}
  </style>
